import ContactUsBelow from "../components/ContactUsBelow";
import ContentBelow from "../components/ContentBelow";
import Head from "../components/Head";
import background from "../images/services_background.png";
import RopeManImg from "../images/Apply Pages-Man & Rope.png";
import RAFAdvance from "../components/Forms/RAF-Advance";
import { useState, useEffect } from "react";
import PropertySellers from "../components/Forms/PropertySellers";
import AttorneyForm from "../components/Forms/AttorneyForm";
import classess from "../components/ApplyNow.module.css";
import AgentsandAttImg from "../images/Apply Now-Agents & Attorneys.png";
import PropertyAIDA from "../components/Forms/PropertyAIDA";
import PropSellerImg from "../images/Apply Now-Property Sellers.png";
import PropertyOthers from "../components/Forms/PropertyOTHERS";
import AidaImg from "../images/Aida.png";
import ApplyNowNew from "../images/ApplyNow_New.png";
import InfoCardBlock from "../components/Forms/Infocard/InfoCardBlock";
import { useLocation } from "react-router-dom";
import LinkButtons from "../components/LinkButtons";
import AIDAFile from "../components/downloads/AIDA.pdf";
import WBFile from "../components/downloads/WB.pdf";
import { Link } from "react-router-dom";
import RAFClaimantsImg from "../images/Apply Now-RAF Claimants.png";
import THPropOther from "./thankyou/th-prop-other";
import RAFAttImg from "../images/Apply Now-RAF Attorneys.png";
import AdvocatesAccFactoring from "../components/Forms/AdvocatesAccFactoring";
import ApplyAdvImg from "../images/Apply Now-Advocates Accounts Factoring.png";

function Applynow() {
  const location = useLocation();
  const [RafFormIsVisible, setRafFromIsVisible] = useState(true);
  const [PropertySellersFormIsVisible, setPropertySellersIsVisible] =
    useState(false);
  const [AttorneyFormIsVisible, setAttorneyIsVisible] = useState(false);
  const [PropertyAIDAIsVisible, setPropertyAIDAIsVisible] = useState();
  const [PropertyOthersIsVisible, setPropertyOthersIsVisible] = useState();
  const [AdvocateAccFacFormIsVisible, setAdvocateAccFacFormIsVisible] =
    useState();
  const [currentHeading, setHeading] = useState(
    "Apply Now for a RAF Bridging Finance",
  );
  const [upperHeading, setUpperHeading] = useState("Apply Now");

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.get("showRafForm") === "true") {
      setHeading("RAF Claimants-Complete this form to apply for a RAF Advance");
      setUpperHeading("Apply Now for a RAF Advance");
      setRafFromIsVisible(true);
      setAttorneyIsVisible(false);
      setPropertyAIDAIsVisible(false);
      setPropertySellersIsVisible(false);
      setPropertyOthersIsVisible(false);
      setAdvocateAccFacFormIsVisible(false);
    } else if (params.get("showAttorneyForm") === "true") {
      setHeading("Attorney Bridging Finance Application");
      setUpperHeading("Apply Now for Attorney Fee Advance");
      setPropertyAIDAIsVisible(false);
      setAttorneyIsVisible(true);
      setRafFromIsVisible(false);
      setPropertySellersIsVisible(false);
      setPropertyOthersIsVisible(false);
      setAdvocateAccFacFormIsVisible(false);
    } else if (params.get("showPropertyForm") === "true") {
      setHeading("Property Bridging Finance Application");
      setUpperHeading("Apply Now for a Property Advance");
      setAttorneyIsVisible(false);
      setRafFromIsVisible(false);
      setPropertySellersIsVisible(true);
      setPropertyOthersIsVisible(false);
      setPropertyAIDAIsVisible(false);
      setAdvocateAccFacFormIsVisible(false);
      // } else if (params.get("showPropertyAIDAForm") === "true") {
      //   setHeading("Welcome AIDA Agents.");
      //   setUpperHeading("AIDA Agents");
      //   setPropertyAIDAIsVisible(true);
      //   setAttorneyIsVisible(false);
      //   setRafFromIsVisible(false);
      //   setPropertySellersIsVisible(false);
      //   setPropertyOthersIsVisible(false);
      //   setAdvocateAccFacFormIsVisible(false);
    } else if (params.get("showPropertyOthersForm") === "true") {
      setHeading("Welcome Attorney & Agents.");
      setUpperHeading("Apply Now for a Property Advance");
      setPropertyAIDAIsVisible(false);
      setAttorneyIsVisible(false);
      setRafFromIsVisible(false);
      setPropertySellersIsVisible(false);
      setAttorneyIsVisible(false);
      setPropertyOthersIsVisible(true);
      setAdvocateAccFacFormIsVisible(false);
    } else if (params.get("showAdvocateAccFacForm") === "true") {
      setHeading("Advocate Accounts Factoring");
      setUpperHeading("Apply for Advocate Accounts Factoring");
      setPropertyAIDAIsVisible(false);
      setAttorneyIsVisible(false);
      setRafFromIsVisible(false);
      setPropertySellersIsVisible(false);
      setAttorneyIsVisible(false);
      setPropertyOthersIsVisible(false);
      setAdvocateAccFacFormIsVisible(true);
    }
  }, [location.search]); // re-run when location.search changes
  function showPropertyForm() {
    setPropertySellersIsVisible(true);
    setHeading("Property Bridging Finance Application");
    setUpperHeading("Apply Now for a Property Advance");
    setRafFromIsVisible(false);
    setAttorneyIsVisible(false);
  }
  function showRafForm() {
    setRafFromIsVisible(true);
    setHeading("RAF Bridging Finance Application");
    setUpperHeading("Apply Now for a RAF Advance");
    setPropertySellersIsVisible(false);
    setAttorneyIsVisible(false);
    setPropertyAIDAIsVisible(false);
    setAdvocateAccFacFormIsVisible(false);
  }
  function showAttorneyForm() {
    setPropertySellersIsVisible(false);
    setHeading("Attorney Bridging Finance Application");
    setUpperHeading("Apply Now for Attorney Fee Advance");
    setRafFromIsVisible(false);
    setAttorneyIsVisible(true);
    setAdvocateAccFacFormIsVisible(false);
  }
  function showAdvocateAccFacForm() {
    setPropertySellersIsVisible(false);
    setHeading("Attorney Bridging Finance Application");
    setUpperHeading("Apply Now for Attorney Fee Advance");
    setRafFromIsVisible(false);
    setAttorneyIsVisible(false);
    setAdvocateAccFacFormIsVisible(true);
  }

  return (
    <>
      <Head imageUrl={background}>
        <h2 className="heading_space">{upperHeading}</h2>
      </Head>
      <ContentBelow>
        <div className="container">
          <div className="row h-auto justify-content-lg-evenly">
            <div className="">
              {/* <h3>{currentHeading}</h3> */}

              {AdvocateAccFacFormIsVisible ? (
                <>
                  <InfoCardBlock
                    image={ApplyNowNew}
                    //heading={"Advocate Accounts Factoring Application"}
                    onButtonClick={showAdvocateAccFacForm}
                    buttonText={"Click here"}
                    belowCardText={""}
                    Form={
                      <>
                        <AdvocatesAccFactoring
                          heading={
                            "Complete this form to apply for Advocate Accounts Factoring"
                          }
                        />
                      </>
                    }
                  />
                </>
              ) : null}

              {PropertySellersFormIsVisible ? (
                <>
                  <InfoCardBlock
                    isVisible={PropertySellersFormIsVisible}
                    title={""}
                    description={""}
                    image={ApplyNowNew}
                    //heading={"Property Bridging Finance Application"}
                    onButtonClick={PropertySellersFormIsVisible}
                    buttonText={"Click here"}
                    Form={
                      <>
                        <PropertySellers
                          heading={
                            "Use this form to apply for property bridging finance for yourself or your client"
                          }
                        />
                      </>
                    }
                    CardBelow={"Fast Track your Application"}
                    DownloadLink={
                      <>
                        <Link to={WBFile} target="_blank" download>
                          here
                        </Link>{" "}
                      </>
                    }
                  />
                </>
              ) : null}
              {PropertyAIDAIsVisible ? (
                <>
                  <InfoCardBlock
                    image={ApplyNowNew}
                    isVisible={PropertyAIDAIsVisible}
                    //heading={"Welcome AIDA Agents"}
                    onButtonClick={PropertySellersFormIsVisible}
                    buttonText={"Click here"}
                    pText={""}
                    Form={
                      <>
                        {" "}
                        <div>
                          <PropertyAIDA
                            heading={
                              "Use this form to apply for property bridging finance for yourself or your client"
                            }
                          />
                        </div>
                      </>
                    }
                    CardBelow={"Fast Track your Application"}
                    DownloadLink={
                      <>
                        {" "}
                        <Link to={AIDAFile} target="_blank" download>
                          here
                        </Link>{" "}
                      </>
                    }
                  />
                </>
              ) : null}

              {AttorneyFormIsVisible ? (
                <>
                  <InfoCardBlock
                    image={ApplyNowNew}
                    //heading={"RAF Attorney: Bridging Finance Application"}
                    onButtonClick={showRafForm}
                    buttonText={"Click here"}
                    belowCardText={"RAF Claimants – To apply:"}
                    Form={
                      <>
                        <AttorneyForm
                          heading={
                            "RAF Attorney- Complete this form to apply for an Attorney Advance"
                          }
                        />
                      </>
                    }
                  />
                </>
              ) : null}
              {PropertyOthersIsVisible ? (
                <>
                  <InfoCardBlock
                    image={ApplyNowNew}
                    isVisible={PropertyOthersIsVisible}
                    //heading={"Welcome Attorneys & Agents"}
                    onButtonClick={RafFormIsVisible}
                    buttonText={"Click here"}
                    CardBelow={"Fast Track your Application"}
                    DownloadLink={
                      <>
                        <Link to={WBFile} target="_blank" download>
                          here
                        </Link>{" "}
                      </>
                    }
                    Form={
                      <>
                        <PropertyOthers
                          heading={
                            "Use this form to apply for property bridging finance for yourself or your client"
                          }
                        />
                      </>
                    }
                  />
                </>
              ) : null}

              {RafFormIsVisible ? (
                <>
                  <InfoCardBlock
                    image={ApplyNowNew}
                    //heading={"RAF Claimants: Bridging Finance Application"}
                    onButtonClick={showAttorneyForm}
                    buttonText={"Click here"}
                    belowCardText={
                      "RAF Attorneys – To apply for a Fee Advance :"
                    }
                    Form={
                      <>
                        <div>
                          <RAFAdvance
                            heading={
                              "RAF Claimants-Complete this form to apply for a RAF Advance"
                            }
                          />
                        </div>
                      </>
                    }
                  />
                </>
              ) : null}
            </div>
          </div>
        </div>
      </ContentBelow>

      <ContactUsBelow />
      <div className="text-center">
        <img
          src={RopeManImg}
          alt="RAF Logo"
          width={800}
          className={classess.img}
        />
      </div>
    </>
  );
}
export default Applynow;
